<div class="card border-0 open-positions-widget shadow-sm">
  <div class="card-header bg-white border-bottom-0 ">
    <h5 class="card-title text-muted mb-0">{{ 'DASHBOARD.OPEN_POSITIONS_BY_TEAM' | translate }}</h5>
  </div>
  <div class="card-body">
    @if (isLoading) {
      <div class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p>{{ 'COMMON.LOADING' | translate }}</p>
      </div>
    } @else if (error) {
      <div class="alert alert-danger" role="alert">
        {{ error }}
      </div>
    } @else {
      @if (openPositionsByTeam.length > 0) {
        @for (team of openPositionsByTeam; track team.team_id) {
          <div class="list-group-item p-2 m-3 mb-0 border rounded">
            <h6 class="text-primary">
              <a [routerLink]="['/teams', team.team_id]" class="team-link fw-semibold text-decoration-none">
                {{ team.team_name }}
              </a>
            </h6>
            <ul class="list-group list-group-flush">
              @if (hasOpenPositions(team)) {
                @for (position of team.positions; track position.role_id) {
                  <li class=" list-group-item d-flex justify-content-between align-items-center">
                    <span>
                      <a [routerLink]="['/roles', position.role_id]" class="role-link text-muted">{{ position.role_name }}</a>
                    </span>
                    <span class="badge bg-danger rounded-pill">{{ position.delta }} {{ 'DASHBOARD.FTE_NEEDED' | translate }}</span>
                  </li>
                }
              } @else {
                <li class="text-muted">No open positions for this team.</li>
              }
            </ul>
          </div>
        }
      } @else {
        <p class="text-center text-muted">No open positions found across all teams.</p>
      }
    }
  </div>
</div>